import { inject, Injectable } from '@angular/core';
import { ResellerPurchaseHistoryService } from '@services/purchase-history.service';
import {
  PurchaseHistory,
  PurchaseHistoryParams,
  ResellerPurchaseHistoryResponseData,
  TransactionDetailsResponse
} from 'mbs-ui-shared@components/purchase-history/models/purchase-history.types';
import { PurchaseHistoryService } from 'mbs-ui-shared@components/purchase-history/services/purchase-history.service';
import { PagedResponse } from 'mbs-ui-shared@models/Paging';
import { map, Observable } from 'rxjs';

@Injectable()
export class ResellerPurchaseHistoryWrapper extends PurchaseHistoryService {
  private service = inject(ResellerPurchaseHistoryService);

  constructor() {
    super();
  }

  public override getHistory(params: PurchaseHistoryParams): Observable<PagedResponse<PurchaseHistory>> {
    return this.service.getHistory(params).pipe(
      map(
        (response: PagedResponse<ResellerPurchaseHistoryResponseData>) =>
          ({
            data: response.data.map((item: ResellerPurchaseHistoryResponseData) => this.adapterHistoryData(item)),
            total: response.total
          }) as PagedResponse<PurchaseHistory>
      )
    );
  }

  public override exportHistory(params: PurchaseHistoryParams): Observable<string> {
    return this.service.exportHistory(params);
  }

  public override getDetails(id: string): Observable<TransactionDetailsResponse> {
    return this.service.getDetails(id);
  }

  private adapterHistoryData(data: ResellerPurchaseHistoryResponseData): PurchaseHistory {
    return { ...data.transaction, providerEmail: data.providerEmail } as PurchaseHistory;
  }

  public override getInvoicePdf(id: string) {
    return this.service.getInvoicePdf(id);
  }

  public override getReceiptPdf(id: string) {
    return this.service.getReceiptPdf(id);
  }
}
